import React, { useEffect, useRef, useState } from 'react';
import styles from './SubtitleActions.module.scss';
import cx from 'classnames';
import Icon from '../../../../components/Icon/Icon';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../../../components//Tooltip/Tooltip';

const SubtitleActions = ({
  addSubtitle = () => {},
  mergeSubtitle = () => {},
  showMerge,
  isAddPossible,
  isMergePossible,
  isFirstSubtitle,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [throttleVisible, setThrottleVisible] = useState(false);

  const [isHover, setIsHover] = useState(false);

  const timeout = useRef(null);
  const actionsRef = useRef();

  const { t } = useTranslation();

  useEffect(() => {
    if (timeout.current !== null) {
      clearTimeout(timeout.current);

      if (isVisible !== throttleVisible) {
        timeout.current = setTimeout(() => {
          setThrottleVisible(isVisible);
          timeout.current = null;
        }, 150);
      }
    } else {
      if (isVisible !== throttleVisible) {
        timeout.current = setTimeout(() => {
          setThrottleVisible(isVisible);
          timeout.current = null;
        }, 150);
      }
    }
  }, [isVisible]);

  useEffect(() => {
    if (throttleVisible) {
      setTimeout(() => actionsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 200);
    }
  }, [throttleVisible]);

  const handleAddSubtitle = () => {
    if (isAddPossible) {
      addSubtitle();
      setThrottleVisible(false);
      setIsVisible(false);
    }
  };

  const handleMergeSubtitle = () => {
    mergeSubtitle();
    setThrottleVisible(false);
    setIsVisible(false);
  };

  return (
    <div
      onMouseOver={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      className={cx(styles.container, {
        [styles.containerVisible]: throttleVisible,
        [styles.firstContainer]: isFirstSubtitle,
      })}
      ref={actionsRef}
    >
      <div className={styles.line} />
      {throttleVisible && (
        <>
          <div className={styles.actionContainer} onClick={handleAddSubtitle}>
            <div
              className={cx(styles.action, { [styles.disabledAction]: !isAddPossible })}
              onMouseOver={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
            >
              <Icon src="addSubtitle" className={styles.actionIcon} />
              <span>{t('subtitles.editor.add')}</span>
            </div>
            {!isAddPossible && (
              <Tooltip
                text={t('subtitles.editor.add.tooltip')}
                isHover={isHover}
                classNameTooltip={cx({ [styles.tooltip]: !isFirstSubtitle, [styles.tooltipFirst]: isFirstSubtitle })}
              />
            )}
          </div>
          {showMerge && isMergePossible && (
            <div className={styles.actionContainer}>
              <div className={styles.action} onClick={handleMergeSubtitle}>
                <Icon src="mergeSubtitle" className={styles.actionIcon} />
                <span>{t('subtitles.editor.merge')}</span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SubtitleActions;
